import axios from "axios";
import store from './../index'
import { getCurrentDateTimeString } from '../../utils/dateTime';
export default {
  state: {
    analyzes: null,
  },
  getters: {
    ANALYZES: state => {
      return state.analyzes;
    },
  },
  mutations: {
    SET_ANALYZES: (state, payload) => {
      state.analyzes = payload;
    },
  },
  actions: {
    ANALYZES: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Report/GetPriceAnalysisAsync`, payload)
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              store.commit('SET_ANALYZES', data);
              resolve(data);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    DOWNLOAD_EXCEL_FILE: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Report/DownloadExcelFileAsync`, payload, {
            responseType: 'blob'
          })
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              let url = window.URL.createObjectURL(new Blob([data]));
              let link = document.createElement('a');
              link.href = url;

              const filename = `Ценевой_анализ_${getCurrentDateTimeString()}.xlsx`;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              
              resolve(true);
            }
            if (status === 204) {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    FILIALS_PRICE_ACTUALITY: async () => {
      try {
        const { data } = await axios.get(`/Report/GetFilialsPriceActualityAsync`);
        return data;
      } catch (error) {
        const Snackbar = {
          text: error.response?.data?.message
            || error.response?.data?.title
            || 'Не удалось загрузить отчёт по актуальности цен',
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        };
        store.commit('SET_SNACKBAR', Snackbar);
        throw error;
      }
    },
    RATING_REPORT_FILTER_OPTIONS: async () => {
      try {
        const { data } = await axios.get(`/RatingReport/GetFilterOptionsAsync`);
        return data;
      } catch (error) {
        const Snackbar = {
          text: error.response?.data?.error
            || 'Не удалось загрузить справочники отчёта',
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        };
        store.commit('SET_SNACKBAR', Snackbar);
        throw error;
      }
    },
    DOWNLOAD_RATING_REPORT: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/RatingReport/DownloadAsync`, payload, {
            responseType: 'blob'
          })
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              let url = window.URL.createObjectURL(new Blob([data]));
              let link = document.createElement('a');
              link.href = url;

              const filename = `Отчет_рейтинг_${getCurrentDateTimeString()}.xlsx`;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              link.remove();
              window.URL.revokeObjectURL(url);

              resolve(true);
            }
            if (status === 204) {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    TOP_PRODUCTS_SOLD: async () => {
      try {
        const { data } = await axios.get(`/TopProductsSold/GetAllAsync`);
        return data;
      } catch (error) {
        const Snackbar = {
          text: error.response?.data?.message
            || error.response?.data?.title
            || 'Не удалось загрузить топ продаваемых товаров',
          timeout: 7500,
          color: 'error',
          linkText: '',
          show: true,
        };
        store.commit('SET_SNACKBAR', Snackbar);
        throw error;
      }
    },
    DOWNLOAD_AVERAGE_PRICES_REPORT: (commit, payload) => {
      return new Promise((resolve, reject) => {
        axios
          .post(`/Report/DownloadAveragePricesPeport`, payload, {
            responseType: 'blob'
          })
          .then(({
            data,
            status
          }) => {
            if (status === 200) {
              let url = window.URL.createObjectURL(new Blob([data]));
              let link = document.createElement('a');
              link.href = url;

              const filename = `Доли_продаж_${getCurrentDateTimeString()}.xlsx`;
              link.setAttribute('download', filename);
              document.body.appendChild(link);
              link.click();
              
              resolve(true);
            }
            if (status === 204) {
              resolve(false);
            }
          })
          .catch(error => {
            reject(error);
          });
      })
    }
  },
};